import { ROLE_CANDIDATE, ROLE_CANDIDATE_EPG } from "utils/ConstantsAndNum";
import { UserType } from "state/User/types";

interface IUserProfileProps {
  user: UserType | null;
}

const getRoleDisplayName = (role: string): string => {
  const candidateRoles = [ROLE_CANDIDATE.toUpperCase(), ROLE_CANDIDATE_EPG.toUpperCase()];
  return candidateRoles.includes(role) ? "Postulante" : role;
};

const UserProfile = ({ user }: IUserProfileProps) => {
  return (
    <>
      {user && (
        <section aria-labelledby="user-profile" className="flex relative">
          <div className="mr-5" id="user-profile">
            <div className="text-color-dark ">
              <span>Hola,</span>
              <strong className="ml-1 font-bold">{user?.firstName}</strong>
            </div>
            <div className=" flex text-end text-color-01 justify-end mt-1">
              <span className="text-small-02 font-normal" aria-live="polite">
                 {getRoleDisplayName(user?.role)}
              </span>
            </div>
          </div>
          <div className="w-14 h-14 bg-grey-10 rounded-full flex justify-center items-center">
            <span
              className="font-bold text-subheading-01 uppercase"
              aria-label={`Avatar de ${user?.firstName}`}
            >
              {user?.firstName?.[0]}
            </span>
          </div>
        </section>
      )}
    </>
  );
};

export default UserProfile;
